<template>
  <div id="app" :class="{ 'has-marquee': showMarquee }">
    <!-- MARQUEE GLOBAL -->
    <div class="global-marquee" v-if="showMarquee">
        <div class="marquee-content-wrapper">
             <div class="marquee-text">
                <span v-for="n in 10" :key="n">
                    {{ ajustes.mensaje_header }} <span class="separator mx-4">•</span>
                </span>
             </div>
        </div>
    </div>

    <div>
      <!-- Header con logo, íconos y menú horizontal (escritorio) -->
      <header
        class="custom-header"
        :class="{ 'header-with-marquee': showMarquee, 'is-hidden': headerHidden }"
        id="menuFijo"
      >
        <div class="header-container is-max-width">
          <!-- Left: Nav -->
          <nav class="desktop-menu">
            <router-link to="/" class="nav-link">INCIO</router-link>
            <router-link to="/tienda" class="nav-link">CATÁLOGO</router-link>
            <router-link to="/nosotros" class="nav-link">NOSOTROS</router-link>
            <router-link to="/politicas" class="nav-link">POLÍTICAS</router-link>
            <a @click="mostrarMayoristas" class="nav-link nav-highlight">MAYORISTAS</a>
          </nav>

          <!-- Center: Logo -->
          <router-link to="/" class="logo-wrapper">
            <img
            class="logo"
            src="img/maxica-logo-header.jpg"
            alt="Logo Maxica"
          />
          </router-link>

          <!-- Right: Icons -->
          <div class="icon-links">
             <router-link to="/descargar-catalogo" class="icon-item" title="Descargar Catálogo">
                <i class="mdi mdi-download-outline"></i>
             </router-link>
             <router-link to="/maxi-puntos" class="icon-item" title="Maxi Puntos">
                <i class="mdi mdi-star-circle-outline"></i>
             </router-link>
             <a v-if="!logeado" @click="abrirLogin" class="icon-item" title="Ingresar">
                <i class="mdi mdi-account-outline"></i>
             </a>
             <router-link v-else to="/perfil" class="icon-item" title="Mi Perfil">
                <i class="mdi mdi-account-check-outline"></i>
             </router-link>
             <a class="icon-item" @click="$store.commit('toggleCarrito', true)" title="Carrito">
                 <div class="cart-icon-wrapper">
                     <i class="mdi mdi-cart-outline"></i>
                     <span v-if="$store.getters.conteoCarrito > 0" class="cart-badge">{{ $store.getters.conteoCarrito }}</span>
                 </div>
             </a>
          </div>
        </div>
      </header>

      <header
        class="mobile-store-header"
        :class="{ 'mobile-header-with-marquee': showMarquee }"
      >
        <button class="mobile-icon-button" type="button" @click="menuOpen = true" aria-label="Abrir menu">
          <i class="mdi mdi-menu"></i>
        </button>
        <router-link to="/" class="mobile-logo-wrapper">
          <img src="img/maxica-logo.jpg" alt="Maxica" />
        </router-link>
        <div class="mobile-header-actions">
          <router-link to="/maxi-puntos" class="mobile-icon-button" aria-label="MaxiPuntos">
            <i class="mdi mdi-star-circle-outline"></i>
          </router-link>
          <button
            v-if="!logeado"
            class="mobile-icon-button"
            type="button"
            @click="abrirLogin"
            aria-label="Ingresar"
          >
            <i class="mdi mdi-account-outline"></i>
          </button>
          <router-link v-else to="/perfil" class="mobile-icon-button" aria-label="Perfil">
            <i class="mdi mdi-account-check-outline"></i>
          </router-link>
          <button class="mobile-icon-button cart-mobile-button" type="button" @click="$store.commit('toggleCarrito', true)" aria-label="Carrito">
            <i class="mdi mdi-shopping-outline"></i>
            <span v-if="$store.getters.conteoCarrito > 0" class="cart-badge mobile-cart-badge">{{ $store.getters.conteoCarrito }}</span>
          </button>
        </div>
      </header>

      <transition name="side-fade">
        <div v-if="menuOpen" class="mobile-menu-overlay" @click="menuClose"></div>
      </transition>
      <aside class="mobile-side-menu" :class="{ open: menuOpen }">
        <div class="mobile-side-head">
          <div class="side-logo-box">
            <img src="img/maxica-logo.jpg" alt="Maxica" />
          </div>
          <button type="button" class="side-close" @click="menuClose" aria-label="Cerrar menu">
            <i class="mdi mdi-close"></i>
          </button>
        </div>

        <div class="side-session-card">
          <div>
            <strong>{{ logeado ? (rol || 'Cliente Maxica') : 'Tu cuenta Maxica' }}</strong>
            <span>
              {{ logeado ? 'Pedidos, puntos y datos de envio' : 'Ingresa con tu telefono' }}
            </span>
          </div>
          <button v-if="!logeado" type="button" @click="abrirLogin">Ingresar</button>
          <router-link v-else to="/perfil" @click.native="menuClose">Ver perfil</router-link>
        </div>

        <nav class="side-nav-list">
          <router-link to="/" @click.native="menuClose"><i class="mdi mdi-home-outline"></i> Inicio</router-link>
          <router-link to="/tienda" @click.native="menuClose"><i class="mdi mdi-storefront-outline"></i> Tienda</router-link>
          <router-link to="/maxi-puntos" @click.native="menuClose"><i class="mdi mdi-star-circle-outline"></i> MaxiPuntos</router-link>
          <router-link to="/descargar-catalogo" @click.native="menuClose"><i class="mdi mdi-download-outline"></i> Descargar catalogo</router-link>
          <router-link to="/nosotros" @click.native="menuClose"><i class="mdi mdi-account-group-outline"></i> Nosotros</router-link>
          <router-link to="/politicas" @click.native="menuClose"><i class="mdi mdi-file-document-outline"></i> Terminos y condiciones</router-link>
          <button type="button" @click="mostrarMayoristas"><i class="mdi mdi-handshake-outline"></i> Mayoristas</button>
          <button v-if="logeado" type="button" @click="cerrarSesion"><i class="mdi mdi-logout"></i> Salir</button>
        </nav>
      </aside>
    </div>
    <!-- carrito lateral -->
    <carrito-lateral />

    <!-- login controlado por mostrarLogin -->
    <div v-if="mostrarLogin" class="modal-overlay">
      <div class="modal-container">
        <button class="modal-close" @click="menuClose">×</button>

        <inicio-sesion
          v-if="mostrarLogin"
          :mostrarInicio="mostrarLogin"
          @login="logueado"
          @menuClose="menuClose"
        />
      </div>
    </div>

    <!-- aquí inyecta o el catálogo o el detalle -->
    <div class="app-content" :style="{ paddingTop: appContentPadding }">
      <mantenimiento-catalogo
        v-if="catalogoMantenimiento && rutaEnMantenimiento"
        :numero-whatsapp="catalogoWhatsapp"
        :ocultar-whatsapp="esUsuarioPosCatalogo"
      />
      <router-view
        v-else
        :esAdmin="logeado"
        :catalogoMantenimiento="catalogoMantenimiento"
      />
    </div>

    <!-- Menú inferior móvil -->
    <nav class="mobile-bottom-menu">
      <router-link class="mobile-nav-item" to="/">
        <i class="mdi mdi-home-outline"></i>
        <span>Inicio</span>
      </router-link>
      <router-link class="mobile-nav-item" to="/tienda">
        <i class="mdi mdi-view-grid-outline"></i>
        <span>Catálogo</span>
      </router-link>
      <router-link class="mobile-nav-item" to="/nosotros">
        <i class="mdi mdi-account-group-outline"></i>
        <span>Nosotros</span>
      </router-link>
      <router-link class="mobile-nav-item" to="/politicas">
        <i class="mdi mdi-file-document-outline"></i>
        <span>Políticas</span>
      </router-link>
      <button type="button" class="mobile-nav-item" @click="mostrarMayoristas">
        <i class="mdi mdi-handshake-outline"></i>
        <span>Mayoristas</span>
      </button>
      <router-link class="mobile-nav-item" to="/maxi-puntos">
        <i class="mdi mdi-gift-outline"></i>
        <span>MaxiPuntos</span>
      </router-link>
      <router-link class="mobile-nav-item is-download" to="/descargar-catalogo">
        <i class="mdi mdi-download"></i>
        <span>Descargar</span>
      </router-link>
      <button
        v-if="logeado"
        type="button"
        class="mobile-nav-item"
        @click="irAPerfil"
      >
        <i class="mdi mdi-clipboard-text-outline"></i>
        <span>Mis pedidos</span>
      </button>
      <router-link
        v-if="logeado"
        class="mobile-nav-item"
        :to="{ path: '/maxi-puntos', query: { modal: 'consulta' } }"
      >
        <i class="mdi mdi-star-circle-outline"></i>
        <span>Mis puntos</span>
      </router-link>
      <button
        v-if="logeado"
        type="button"
        class="mobile-nav-item is-logout"
        @click="cerrarSesion"
      >
        <i class="mdi mdi-logout"></i>
        <span>Salir</span>
      </button>
    </nav>

    <!-- botón flotante WhatsApp -->
    <div
      v-if="mostrarWhatsappFlotante"
      class="boton-whatsapp-wrapper"
      @mouseenter="mostrarTooltip = true"
      @mouseleave="mostrarTooltip = false"
      @touchstart="mostrarTooltip = true"
    >
      <div v-show="mostrarTooltip" class="tooltip-flotante">
        ¿Necesitas ayuda?
      </div>
      <a
        :href="whatsappFlotanteUrl"
        target="_blank"
        class="boton-whatsapp-limpio"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/5/5e/WhatsApp_icon.png"
          alt="WhatsApp"
          width="60"
          height="60"
        />
      </a>
    </div>
  </div>
</template>

<script>
import AyudanteSesion from "./Servicios/AyudanteSesion";
import HttpService from "./Servicios/HttpService"; // Added
import { NotificacionesMixin } from "./components/mixins/NotificacionesMixin";
import CarritoLateral from "./components/Catalogo/CarritoLateral.vue";
import MantenimientoCatalogo from "./components/Catalogo/MantenimientoCatalogo.vue";
import InicioSesion from "./components/Usuarios/InicioSesion";
import Swal from "sweetalert2";

export default {
  name: "App",
  components: { CarritoLateral, MantenimientoCatalogo, InicioSesion },
  mixins: [NotificacionesMixin],

  data() {
    return {
      logeado: false,
      mostrarLogin: false,
      mostrarTooltip: false,
      menuOpen: false,
      mostrarTooltipMoneda: false,
      esMovil: false,
      headerHidden: false,
      lastScrollY: 0,
      rol: localStorage.getItem("rol") || "",
      ajustes: {}, // Global settings
      catalogoMantenimiento: false,
      catalogoWhatsapp: "3243717299",
    };
  },
  computed: {
      esMayorista() {
          return this.rol === "mayorista" || this.rol === "administrador";
      },
      esUsuarioPosCatalogo() {
          return ["administrador", "cajero", "inven"].includes(this.rol);
      },
      showMarquee() {
          return this.ajustes.mensaje_header && this.ajustes.mensaje_header.length > 2;
      },
      appContentPadding() {
          return this.esMovil ? (this.showMarquee ? '84px' : '56px') : (this.showMarquee ? '86px' : '56px');
      },
      rutaEnMantenimiento() {
          return [
              "HomeMaxica",
              "CatalogoWeb",
              "CatalogoCategoria",
              "ProductoDetalle",
              "FinalizarCompra",
              "DescargarCatalogo",
          ].includes(this.$route.name);
      },
      rutaSinRecordatorioRegistro() {
          return ["NosotrosMaxica", "LinksMaxica"].includes(this.$route.name);
      },
      numeroWhatsappNormalizado() {
          const digitos = String(this.catalogoWhatsapp || "").replace(/\D+/g, "");
          if (digitos.length === 12 && digitos.startsWith("57")) return digitos.slice(2);
          return /^3\d{9}$/.test(digitos) ? digitos : "3243717299";
      },
      whatsappFlotanteUrl() {
          const mensaje = encodeURIComponent("Hola, necesito informacion");
          return `https://wa.me/57${this.numeroWhatsappNormalizado}?text=${mensaje}`;
      },
      mostrarWhatsappFlotante() {
          return !this.esUsuarioPosCatalogo &&
            !this.mostrarLogin &&
            this.$route.name !== "FinalizarCompra" &&
            !this.$store.getters.mostrarCarrito;
      }
  },

  async mounted() {
    this.logeado = AyudanteSesion.verificarSesion();
    this.verificarRecordatorioRegistro();
    
    // Fetch global settings for Marquee
    try {
        const data = await HttpService.registrar("funciones.php", { accion: "obtenerDatosHome" });
        if(data && data.ajustes) {
            this.ajustes = data.ajustes;
            this.catalogoMantenimiento = !!Number(
              data.ajustes.catalogo_mantenimiento ||
              data.ajustes.catalogoMantenimiento ||
              0
            );
            this.catalogoWhatsapp =
              data.ajustes.catalogo_whatsapp ||
              data.ajustes.catalogoWhatsapp ||
              this.catalogoWhatsapp;
        }
    } catch(e) { console.error(e); }

    setTimeout(() => {
      this.mostrarTooltip = true;
      setTimeout(() => (this.mostrarTooltip = false), 5000);
    }, 5000);

    const rol = localStorage.getItem("rol");
    if (rol === "cajero" || rol === "inven" || rol === "administrador") {
      const nombre = localStorage.getItem("nombre") || "";
      Swal.fire({
        icon: "info",
        title: "Estas en modo APARTADO DE EMPLEADO",
        html: `Todo pedido se apartará a nombre de <strong>${nombre}</strong>`,
        confirmButtonColor: "#2c73d2",
      });
    }

    this.esMovil = window.innerWidth <= 768;
    if (this.esMovil) {
      this.mostrarTooltipMaxi();
      this.lastScrollY = window.scrollY;
      window.addEventListener("scroll", this.onScroll, { passive: true });
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },

  methods: {
    mostrarMayoristas() {
      this.menuOpen = false;

      const rol = localStorage.getItem("rol");

      // ✅ Mostrar solo si NO tiene rol=mayorista
      if (!rol || rol !== "mayorista") {
        Swal.fire({
          title:
            '<span style="font-family: Poppins, Arial, sans-serif; font-size: 2rem; font-weight:700; color:#2c73d2;">¿Quieres ser un aliado mayorista?</span>',
          html: `
        <div style="font-family: Poppins, Arial, sans-serif; color: #1e293b; margin-top:10px; text-align:center;">
          <p style="font-size: 16px; font-weight: 400; margin-bottom:16px;">
            Ahora puedes hacer tu registro de forma <span style="font-weight:600;">autogestionada</span> en línea.<br>
            Completa el formulario y activa tu cuenta mayorista sin esperas.
          </p>
          
          <div style="margin-bottom: 18px;">
            <a
              href="#"
              id="registroMayoristaBtn"
              style="
                background-color: #2c73d2;
                color: white;
                padding: 10px 20px;
                border-radius: 8px;
                font-size: 16px;
                font-weight: 600;
                text-decoration: none;
                transition: background 0.3s;"
              onmouseover="this.style.backgroundColor='#1b365d'"
              onmouseout="this.style.backgroundColor='#2c73d2'"
            >
              Ir al formulario de registro
            </a>
          </div>

          <hr style="margin:18px 0 12px 0;">
          <div style="font-size:15px; margin-bottom:16px;">
            ¿Ya tienes perfil Maxica?
            <a href="#" id="iniciarSesionBtn" style="color:#2c73d2; font-weight:600; text-decoration:underline; margin-left:5px;">
              Ingresa con tu teléfono
            </a>
          </div>
        </div>
      `,
          showConfirmButton: false,
          background: "#fff",
          customClass: {
            popup: "swal2-popup-custom",
          },
          didOpen: () => {
            document
              .getElementById("iniciarSesionBtn")
              ?.addEventListener("click", (e) => {
                e.preventDefault();
                Swal.close();
                this.abrirLogin();
              });

            document
              .getElementById("registroMayoristaBtn")
              ?.addEventListener("click", (e) => {
                e.preventDefault();
                Swal.close();
                this.$router.push("/registro-web");
              });
          },
        });
      }
    },

    verificarRecordatorioRegistro() {
      if (AyudanteSesion.verificarSesion()) return;
      if (this.rutaSinRecordatorioRegistro) return;
      const ultimo = parseInt(localStorage.getItem("registroAviso")) || 0;
      const ahora = Date.now();
      const dia = 24 * 60 * 60 * 1000;
      if (ahora - ultimo > dia) {
        this.mostrarRecordatorioRegistro();
        localStorage.setItem("registroAviso", ahora);
      }
    },

    mostrarRecordatorioRegistro() {
      Swal.fire({
        title:
          '<span class="registro-titulo">Recuerda iniciar sesión</span>',
        html: `
          <p class="registro-texto">
            Ingresa solo con tu número de teléfono para reclamar puntos Maxica,
            ver tus pedidos y completar tus datos de envío más rápido.
          </p>
        <div style="margin-top:20px;">
          <a href="#" id="registroLoginBtn" class="registro-boton">
            Ingresar con mi teléfono
          </a>
        </div>
        `,
        showConfirmButton: false,
        showCancelButton: true, // mostrará el botón “cancel”
        cancelButtonText: "Continuar navegando",
        cancelButtonColor: "#d1d5db", // gris suave (#d1d5db = Tailwind gray‑300)
        focusCancel: true, // para que el foco quede en ese botón
        customClass: {
          popup: "registro-popup",
          container: "registro-container",
          cancelButton: "registro-boton-secundario", // opcional, para ajustes finos
        },
        backdrop: true,
        didOpen: () => {
          document
            .getElementById("registroLoginBtn")
            ?.addEventListener("click", (e) => {
              e.preventDefault();
              Swal.close();
              this.abrirLogin();
            });
        },
      });
    },

    seleccionarCategoria(cat) {
      this.categoriaSeleccion = cat === "Todos" ? null : cat;
      this.marcaSeleccion = null;
    },
    abrirLogin() {
      this.menuOpen = false; // cierra el menú lateral
      this.mostrarLogin = true;
    },
    irAPerfil() {
      this.menuOpen = false;
      if (AyudanteSesion.verificarSesion()) {
        this.$router.push("/perfil");
        return;
      }
      this.abrirLogin();
    },
    irAWhatsApp() {
      if (this.esUsuarioPosCatalogo) return;
      const msj = encodeURIComponent(
        "Hola, estuve viendo su catálogo web y me gustaría recibir más información. ¡Gracias!"
      );
      window.open(`https://wa.me/57${this.numeroWhatsappNormalizado}?text=${msj}`, "_blank");
    },
    logueado(resultado) {
      this.menuClose();
      console.log("llegue al app bien sanony salvo :)");
      AyudanteSesion.establecerSesion(resultado.usuario);
      window.location.reload();
    },
    menuClose() {
      this.mostrarLogin = false;
      this.menuOpen = false;
    },
    mostrarTooltipMaxi() {
      this.mostrarTooltipMoneda = true;
      setTimeout(() => {
        this.mostrarTooltipMoneda = false;
      }, 3000);
    },
    onScroll() {
      if (!this.esMovil) return;
      const current = window.scrollY;
      const delta = current - this.lastScrollY;
      if (current <= 10) {
        this.headerHidden = false;
      } else if (delta > 8) {
        this.headerHidden = true;
      } else if (delta < -8) {
        this.headerHidden = false;
      }
      this.lastScrollY = current;
    },
    cerrarSesion() {
      AyudanteSesion.cerrarSesion();
    },
  },

};
</script>


<style>
.swal2-popup-custom {
  border-radius: 1.2rem;
  font-family: "Poppins", Arial, sans-serif;
  box-shadow: 0 8px 32px 0 rgba(44, 115, 210, 0.11);
  padding-bottom: 26px;
}

/* Estilo suave para SweetAlert */
.swal2-popup-custom {
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
.menu-item-mayoristas {
  font-weight: bold;
  color: #2c73d2;
  cursor: pointer;
  padding: 0 8px;
  transition: color 0.3s;
  border-bottom: 2px solid transparent;
}

.menu-item-mayoristas:hover {
  color: #1b365d;
  border-bottom: 2px solid #2c73d2;
}

.menu-item-descargar {
  font-weight: bold;
  color: #e74c3c !important;
  cursor: pointer;
  padding: 0 8px;
  transition: all 0.3s;
  border-bottom: 2px solid transparent;
  display: flex;
  align-items: center;
  gap: 4px;
}

.menu-item-descargar:hover {
  color: #c0392b !important;
  border-bottom: 2px solid #e74c3c;
}

.menu-item-descargar i {
  font-size: 18px;
}

.menu-item-descargar-movil {
  color: #e74c3c !important;
  display: flex;
  align-items: center;
  gap: 8px;
}

.menu-item-descargar-movil i {
  font-size: 20px;
}

:root {
  --color-fondo: #ffffff;
  --color-texto: #1f2937;
  --color-panel: #f5f7fa;
}

[data-tema="oscuro"] {
  --color-fondo: #1e293b;
  --color-texto: #f1f5f9;
  --color-panel: #334155;
}

/* Estilo del Botón Flotante */

/* Header principal */
/* Header principal */
/* OLD HEADER REMOVED - REPLACED BY NEW STYLES BELOW */

.boton-whatsapp-wrapper {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* 💡 Esto empuja el tooltip hacia la izquierda */
}

.tooltip-flotante {
  background-color: #2c73d2;
  color: white;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 13px;
  margin-bottom: 6px;
  white-space: nowrap;
  transition: all 0.3s ease;
}

.tooltip-flotante[v-show="true"] {
  opacity: 1;
  transform: translateY(0);
}

.boton-whatsapp-limpio {
  display: inline-block;
  border-radius: 50%;
  animation: pulse 2s infinite;
  transition: transform 0.3s ease;
}

.boton-whatsapp-limpio:hover {
  transform: scale(1.1);
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes tooltipFade {
  0% {
    opacity: 0;
    transform: translateY(5px);
  }
  20% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(5px);
  }
}

@keyframes aparecer {
  from {
    transform: scale(0.7);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(34, 36, 54, 0.46);
  backdrop-filter: blur(6px);
  z-index: 5000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  width: 100vw;
  max-width: 800px;
  margin: 0 10px;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 8px 40px 0 rgba(0, 0, 0, 0.22);
  background: transparent; /* deja el fondo al hijo */
  display: flex;
  flex-direction: column;
  /* En móvil ocupará el máximo vertical posible */
  max-height: 98vh;
}

@media (max-width: 768px) {
  .modal-container {
    max-width: 98vw;
    width: 98vw;
    min-width: unset;
    margin: 0 1vw;
    padding: 0;
  }
}

/* ===== Aviso registro mayorista ===== */
.registro-container {
  backdrop-filter: blur(5px);
}

.registro-popup {
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 20px;
  font-family: "Poppins", Arial, sans-serif;
}

.registro-titulo {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2c73d2;
}

.registro-texto {
  color: #1e293b;
  font-size: 16px;
  margin-bottom: 12px;
}

.registro-boton {
  display: inline-block;
  background-color: #2c73d2;
  color: #fff !important;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.3s;
}

.registro-boton:hover {
  background-color: #1b365d;
}

.coin-container {
  position: relative;
}

.coin-icon {
  font-size: 30px;
  color: #ffd700;
  animation: coin-spin 2s linear infinite, coin-shine 1.5s ease-in-out infinite;
}

@keyframes coin-spin {
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(360deg);
  }
}

@keyframes coin-shine {
  0%,
  100% {
    filter: drop-shadow(0 0 0px #ffd700);
  }
  50% {
    filter: drop-shadow(0 0 6px #ffd700);
  }
}

.tooltip-maxipuntos {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #2c73d2;
  color: #fff;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 13px;
  white-space: nowrap;
}

.app-content {
  min-height: 100vh;
}

.mobile-bottom-menu {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-start;
  padding: 5px 6px calc(5px + env(safe-area-inset-bottom));
  z-index: 9997;
  overflow-x: auto;
  gap: 6px;
  scrollbar-width: none;
}

.mobile-bottom-menu::-webkit-scrollbar {
  display: none;
}

.mobile-nav-item {
  flex: 0 0 auto;
  min-width: 76px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  color: #64748b;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 12px;
}

.mobile-nav-item i {
  font-size: 22px;
}

.mobile-nav-item.router-link-exact-active,
.mobile-nav-item.router-link-active {
  color: #2c73d2;
  background: rgba(44, 115, 210, 0.1);
}

.mobile-nav-item.is-download {
  color: #e74c3c;
}

.mobile-nav-item.is-download.router-link-exact-active,
.mobile-nav-item.is-download.router-link-active {
  color: #c0392b;
}

/* =========================================
   NEW PREMIUM HEADER & MARQUEE STYLES
   ========================================= */

/* MARQUEE GLOBAL Styles */
.global-marquee {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10000;
    background: #000;
    color: #fff;
    font-size: 0.74rem;
    height: 30px;
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    margin-bottom: 20px; /* Spacing below marquee */
}
.marquee-content-wrapper {
    width: 100%;
    display: flex;
    overflow: hidden;
    white-space: nowrap;
}
.marquee-text {
    display: inline-block;
    white-space: nowrap;
    animation: marquee 40s linear infinite;
    padding-left: 0; 
    min-width: 100%;
}
.marquee-text span {
    display: inline-block;
}
@keyframes marquee {
    0% { transform: translate(0, 0); }
    100% { transform: translate(-50%, 0); }
}

/* CUSTOM HEADER */
.custom-header {
    margin-top: 0;
    background: #101010;
    padding: 0;
    border-bottom: 1px solid rgba(255,255,255,0.08);
    box-shadow: 0 8px 22px rgba(0,0,0,0.12);
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 9999;
    height: 56px;
    transition: top 0.3s ease;
}
.custom-header.header-with-marquee {
    top: 30px;
}

.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 42px;
}
.header-container.is-max-width {
    max-width: 1400px;
    margin: 0 auto;
}

/* LOGO */
.logo-wrapper {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 164px;
    height: 42px;
    overflow: hidden;
    text-decoration: none;
}
.logo {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
}

.mobile-store-header,
.mobile-menu-overlay,
.mobile-side-menu {
    display: none;
}

.mobile-store-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 54px;
    z-index: 9999;
    background: #111111;
    color: #fff;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    border-bottom: 1px solid rgba(255,255,255,0.08);
}

.mobile-store-header.mobile-header-with-marquee {
    top: 30px;
}

.mobile-logo-wrapper {
    position: absolute;
    left: 50%;
    top: 7px;
    transform: translateX(-50%);
    width: 112px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    background: #060606;
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 7px;
}

.mobile-logo-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.mobile-header-actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 7px;
}

.mobile-icon-button {
    width: 36px;
    height: 36px;
    border: 0;
    background: transparent;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 23px;
    line-height: 1;
    cursor: pointer;
    text-decoration: none;
    position: relative;
}

.mobile-icon-button:hover {
    color: #fff;
}

.mobile-cart-badge {
    top: 2px;
    right: 0;
    background: #d43d3d;
}

.mobile-menu-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.48);
    z-index: 11000;
}

.mobile-side-menu {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: min(86vw, 340px);
    background: #ffffff;
    z-index: 11001;
    transform: translateX(-105%);
    transition: transform 0.22s ease;
    box-shadow: 12px 0 34px rgba(0,0,0,0.18);
    flex-direction: column;
}

.mobile-side-menu.open {
    transform: translateX(0);
}

.mobile-side-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: #111111;
}

.side-logo-box {
    width: 142px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 7px 10px;
    background: #050505;
    border-radius: 7px;
}

.side-logo-box img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.side-close {
    width: 38px;
    height: 38px;
    border: 0;
    background: rgba(255,255,255,0.08);
    color: #fff;
    border-radius: 50%;
    font-size: 22px;
}

.side-session-card {
    margin: 16px;
    padding: 14px;
    background: #faf7f2;
    border: 1px solid #eadfd2;
    border-radius: 8px;
    display: grid;
    gap: 12px;
}

.side-session-card strong,
.side-session-card span {
    display: block;
}

.side-session-card strong {
    color: #161616;
    font-size: 0.98rem;
}

.side-session-card span {
    color: #6a625a;
    font-size: 0.84rem;
    margin-top: 2px;
}

.side-session-card button,
.side-session-card a {
    min-height: 40px;
    border: 0;
    border-radius: 6px;
    background: #111111;
    color: #fff;
    text-decoration: none;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.side-nav-list {
    display: flex;
    flex-direction: column;
    padding: 4px 16px 24px;
    gap: 2px;
}

.side-nav-list a,
.side-nav-list button {
    min-height: 46px;
    border: 0;
    border-bottom: 1px solid #f1eee9;
    background: transparent;
    color: #1f1f1f;
    text-decoration: none;
    font-weight: 650;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 0.95rem;
    text-align: left;
    cursor: pointer;
}

.side-nav-list i {
    font-size: 21px;
    color: #4f4a45;
}

.side-fade-enter-active,
.side-fade-leave-active {
    transition: opacity 0.2s ease;
}

.side-fade-enter,
.side-fade-leave-to {
    opacity: 0;
}

/* DESKTOP MENU - Hidden on Mobile */
.desktop-menu {
    display: none; /* Mobile Default */
    gap: 30px;
    align-items: center;
}

/* ICONS RIGHT */
.icon-links {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-left: auto;
}
.icon-item {
    color: #f5f5f5;
    font-size: 1.3rem;
    position: relative;
    cursor: pointer;
    transition: color 0.3s;
}
.icon-item:hover {
    color: #cfd8e8;
}
.cart-icon-wrapper {
    position: relative;
}
.cart-badge {
    position: absolute;
    top: -5px;
    right: -8px;
    background: #e74c3c;
    color: #fff;
    font-size: 0.6rem;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.nav-link {
    text-decoration: none;
    color: #f5f5f5;
    font-size: 0.85rem;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: uppercase;
    transition: color 0.3s ease;
}
.nav-link:hover {
    color: #d7dfef;
}
.nav-highlight {
    color: #8fb8ff;
    font-weight: 700;
    cursor: pointer;
}

/* MEDIA QUERIES */

/* DESKTOP (>= 769px) */
@media (min-width: 769px) {
    .desktop-menu {
        display: flex; /* Show menu on desktop */
    }
    .mobile-bottom-menu {
        display: none; /* Hide bottom menu on desktop */
    }
}

/* MOBILE (<= 768px) */
@media (max-width: 768px) {
    .global-marquee {
        position: fixed;
        top: 0;
        z-index: 10001;
    }
    
    .custom-header {
        display: none !important;
    }

    .mobile-store-header {
        display: flex;
    }

    .mobile-menu-overlay {
        display: block;
    }

    .mobile-side-menu {
        display: flex;
    }

    .desktop-menu {
        display: none !important;
    }

    /* Adjust content padding: 
       Top: 40px for marquee.
       Bottom: 100px so content is not hidden by bottom menu */
    .app-content {
        padding-bottom: 34px !important; 
    }

    .mobile-bottom-menu {
        display: none !important;
    }

    /* Whatsapp button adjustment to avoid covering bottom menu */
    .boton-whatsapp-wrapper {
        bottom: 20px !important;
    }

    /* Accelerate Marquee on Mobile (Hyper Velocity: 2s) */
    .marquee-text {
        animation-duration: 6s !important; 
    }
}
</style>
